import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Card } from '../../../shared/models/plans';
import { AccountSettingsService } from '../../account-settings.service';

@Component({
  selector: 'cc-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() card: Card;
  @Output() cardChange = new EventEmitter();

  constructor(private accountSettingsService: AccountSettingsService) {}

  ngOnInit() {}

  handleCardChange() {
    this.cardChange.emit();
    this.accountSettingsService.changeCard();
  }
}
